import type { PluginObject } from 'vue';

import { makeRub } from '@/utils/helpers';

interface GlobalFilters {
  makeRub: typeof makeRub
}

const sharedFiltersPlugin: PluginObject<undefined> = {
  install(app) {
    if (this.installed)
      return;

    app.filters = app.prototype.$filters = {
      makeRub
    } satisfies GlobalFilters;

    this.installed = true;
  }
};

declare module 'vue/types/vue' {
  interface VueConstructor {
    filters: GlobalFilters
  }

  interface Vue {
    $filters: GlobalFilters
  }
}

export { sharedFiltersPlugin as default };
